// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Dashboard_mainContainer__2deqe","flexItem":"Dashboard_flexItem__3WhU0","Itemtexts":"Dashboard_Itemtexts__3dGas"};